import * as React from "react";
import { CaseRunClient, ClientResources, CaseRunModel } from "@app/api2/api";
import { BPColumn } from "@common/BPReactTable";
import { anyToDecimal, getRunStatusAsString, isNullOrWhitespace, toSciDecimal, yesNo } from "@common/Utils";
import { Dropdown } from "@/components/bp/bp-ui";
import { buildUrl, AppRoutes } from "../../../../AppRoutes";
import { Link } from "react-router-dom";
import { BPDataTable3 } from "@app/components/React/Common/DataTable/BPDataTable3";

interface MaxLrCaseRunsProps {
    labId: number;
    caseId: number
}

export class MaxLrCaseRuns extends React.Component<MaxLrCaseRunsProps> {
    client: CaseRunClient = new CaseRunClient();
    translationsContext: React.Context<ClientResources>;

    constructor(props, context) {
        super(props, context);
        
    }

    render() {
        const columns: BPColumn<CaseRunModel>[] = [
            {
                Header: "Id",
                accessor: 'id',
                Cell: item => <Link to={buildUrl(AppRoutes.CaseRunDetails, {
                    caseId: this.props.caseId.toString(),
                    caseRunId: item.value.toString(),
                    labId: this.props.labId.toString()
                })}>{item.value}</Link>,
                width: '80px',
            },
            {
                Header: window.translation.common.runType,
                accessor: 'friendlyRunType',
                width: '130px',
                cellTitle: true,
                Filter: (filter) =>
                    <Dropdown placeholder={window.translation.common.runType} clearable label={window.translation.common.runType} value={filter.column.filterValue} selection
                        onChange={(ev, { value }) => {
                            filter.setFilter(filter.column.id, value);
                        }}
                        options={['maxlr', 'maxlr_aic', 'deconv_main', 'gen_sample'].map(key => { return { value: key, text: window.translation.runType[key] } })} />
            },
            {
                Header: window.translation.common.population,
                accessor: 'populationName',
                width: '130px',
                cellTitle: true
            },
            {
                Header: window.translation.common.evidencePlural,
                accessor: 'evidenceList',
                disableSortBy: true,
                cellTitle: true,
                width: '130px',
            },
            {
                Header: <span dangerouslySetInnerHTML={{ __html: window.translation.common.hpDeconvolutionContributors }} />,
                accessor: 'hpContributorsList',
                disableSortBy: true,
                cellTitle: true,
                width: null,
                Cell: item => <div>{!isNullOrWhitespace(item.value) ? item.value : item.row.original.hdContributorsList}</div>,
            },
            {
                Header: <div dangerouslySetInnerHTML={{ __html: window.translation.caseRunView.hpUnknownsShort }} />,
                accessor: 'hpUnknowns',
                width: '60px',
            },
            {
                Header: <div dangerouslySetInnerHTML={{ __html: window.translation.caseRunView.hdUnknownsShort }} />,
                accessor: 'hdUnknowns',
                width: '60px',
            },
            {
                Header: window.translation.caseRunView.useDegradation,
                accessor: 'useDegradation',
                disableSortBy: true,
                Cell: item => <>{yesNo(item.value)}</>,
                width: '60px',
            },
            {
                Header: window.translation.caseRunView.useStutter,
                accessor: 'useStutter',
                disableSortBy: true,
                Cell: item => <>{yesNo(item.value)}</>,
                width: '60px',
            },
            {
                Header: window.translation.caseRunView.useFwStutter,
                accessor: 'useFwStutter',
                disableSortBy: true,
                Cell: item => <>{yesNo(item.value)}</>,
                width: '60px',
            },
            {
                Header: window.translation.caseRunView.likelihoodRatioShort,
                accessor: 'likelihoodRatioStr',
                Cell: item => <>{toSciDecimal(anyToDecimal(item.value), 4)}</>,
                width: '100px',
            },
            {
                Header: window.translation.common.status,
                accessor: 'status',
                disableSortBy: true,
                width: '100px',
                Cell: item => <>{getRunStatusAsString(item.value)}</>,
            },
        ];

        return (
            <BPDataTable3
                storeKey="MaxLrCaseResults"
                singleLine
                fixed
                defaultSortField="id"
                defaultSortAsc={false}
                enableSearch={true}
                dataSource={async (p) => {
                    let pageData = await this.client.getMaxLrCaseRuns(this.props.labId, this.props.caseId, p.perPage, p.page, p.sortBy, p.sortDirection, p.searchValue, p.filters.filter(f => f.id == 'friendlyRunType').map(x => x.value)[0]);
                    return pageData;
                }}
                // expandableRowsComponent={((row) => <MaxLrChildCaseRuns parentId={row.id} {...this.props} />)}
                columns={columns}
            />
        );
    }
}

// interface IMaxLrChildCaseRunsProps {
//     labId: number;
//     caseId: number;
//     parentId: number;
// }

// export const MaxLrChildCaseRuns: React.FunctionComponent<IMaxLrChildCaseRunsProps> = (props) => {
//     const client = new CaseRunClient()

//     const columns: BPColumn<CaseRunModel>[] = [
//         {
//             Header: "Id",
//             accessor: 'id',
//             Cell: item => <Link to={buildUrl(Routes.CaseRunDetails, {
//                 caseId: props.caseId.toString(),
//                 caseRunId: item.value.toString(),
//                 labId: props.labId.toString()
//             })}>{item.value}</Link>,
//             width: '80px',
//         },
//         {
//             Header: window.translation.common.runType,
//             accessor: 'friendlyRunType',
//             width: '130px',
//             cellTitle: true,
//             Filter: (filter) =>
//                 <Dropdown placeholder={window.translation.common.runType} clearable label={window.translation.common.runType} value={filter.column.filterValue} selection
//                     onChange={(ev, { value }) => {
//                         filter.setFilter(filter.column.id, value);
//                     }}
//                     options={['maxlr', 'maxlr_aic', 'deconv_main'].map(key => { return { value: key, text: window.translation.runType[key] } })} />
//         },
//         {
//             Header: window.translation.common.population,
//             accessor: 'populationName',
//             width: '130px',
//             cellTitle: true
//         },
//         {
//             Header: window.translation.common.evidencePlural,
//             accessor: 'evidenceList',
//             disableSortBy: true,
//             cellTitle: true,
//             width: '130px',
//         },
//         {
//             Header: <span dangerouslySetInnerHTML={{ __html: window.translation.common.hpDeconvolutionContributors }} />,
//             accessor: 'hpContributorsList',
//             disableSortBy: true,
//             cellTitle: true,
//             width: null,
//         },
//         {
//             Header: <div dangerouslySetInnerHTML={{ __html: window.translation.caseRunView.hpUnknownsShort }} />,
//             accessor: 'hpUnknowns',
//             width: '60px',
//         },
//         {
//             Header: <div dangerouslySetInnerHTML={{ __html: window.translation.caseRunView.hdUnknownsShort }} />,
//             accessor: 'hdUnknowns',
//             width: '60px',
//         },
//         {
//             Header: window.translation.caseRunView.useDegradation,
//             accessor: 'useDegradation',
//             disableSortBy: true,
//             Cell: item => yesNo(item.value),
//             width: '60px',
//         },
//         {
//             Header: window.translation.caseRunView.useStutter,
//             accessor: 'useStutter',
//             disableSortBy: true,
//             Cell: item => yesNo(item.value),
//             width: '60px',
//         },
//         {
//             Header: window.translation.caseRunView.useFwStutter,
//             accessor: 'useFwStutter',
//             disableSortBy: true,
//             Cell: item => yesNo(item.value),
//             width: '60px',
//         },
//         {
//             Header: window.translation.caseRunView.likelihoodRatioShort,
//             accessor: 'likelihoodRatioStr',
//             Cell: item => toSci(item.value, 4),
//             width: '100px',
//         },
//         {
//             Header: window.translation.common.status,
//             accessor: 'state',
//             disableSortBy: true,
//             width: '100px'
//         },
//     ];


//     return <BPDataTable3
//         singleLine
//         fixed
//         defaultSortField="id"
//         defaultSortAsc={false}
//         enableSearch={true}
//         dataSource={async (p) => {
//             let pageData = await client.getMaxLrChildCaseRuns(props.labId, props.caseId, props.parentId, p.perPage, p.page, p.sortBy, p.sortDirection, p.searchValue, p.filters.filter(f => f.id == 'friendlyRunType').map(x => x.value)[0]);
//             return pageData;
//         }}
//         columns={columns}
//     />

// };



